import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import LessonBar from 'pobble-components/dist/lesson-bar'
import qs from 'qs'

@autobind
class LessonBarHolder extends Component {
  render () {
    const url =  qs.parse(window.location.search, { ignoreQueryPrefix: true })
    const id = url.lessonId
    const title = url.lessonTitle
    const isTeacher = this.props.isTeacher
    return (
      <div>
        {isTeacher && id && <LessonBar id={id} title={title} />}
      </div>
    )
  }
}

export default LessonBarHolder



// WEBPACK FOOTER //
// ./components/search/LessonBarHolder.js